import Repository from "./Repository";
import { getDefaultCRUDMethods } from "./Repository";

const resource = "/Export";

export default {
  ...getDefaultCRUDMethods({ resource }),

  download({ item }) {
    let id = item.id;
    return Repository.get(`${resource}/Download/${id}`);
  }
};
